import { Dropdown } from "semantic-ui-react";

export const NewModalDropdownItemTriggerComponent = (props: {
  props: NewModalDropdownItemTriggerComponentProps;
  setOpen: any;
}) => {
  return (
    <Dropdown.Item onClick={() => props.setOpen(true)}>
      {props.props.label}
    </Dropdown.Item>
  );
};

export type NewModalDropdownItemTriggerComponentProps = {
  type: "dropdown_item";
  label: string;
};
